export const FETCH_QUIZES_START = 'FETCH_QUIZES_START';
export const FETCH_QUIZES_SUCCESS = 'FETCH_QUIZES_SUCCESS';
export const FETCH_QUIZES_ERROR = 'FETCH_QUIZES_ERROR';
export const FETCH_QUIZ_SUCCESS = 'FETCH_QUIZ_SUCCESS';
export const QUIZ_SET_STATE = 'QUIZ_SET_STATE';
export const FINISH_QUIZ = 'FINISH_QUIZ';
export const QUIZ_NEXT_QUESTIONS = 'QUIZ_NEXT_QUESTIONS';
export const Retry_Quiz = 'Retry_Quiz';
export const Create_Quiz_Question = 'Create_Quiz_Question';
export const Reset_Quiz_Creation = 'Reset_Quiz_Creation';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUT_LOGOUT = 'AUT_LOGOUT';

